import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
export function DirectoryPage() {
  const [searchQuery, setSearchQuery] = useState('');
  // Pages data
  const pages = [{
    title: 'Altman Onboarding Survey',
    path: '/assessment',
    description: 'Onboarding Assessment for Altman subscription'
  }
  // More pages can be added here in the future
  ];
  // Filter pages based on search query
  const filteredPages = pages.filter(page => page.title.toLowerCase().includes(searchQuery.toLowerCase()) || page.description.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="flex flex-col items-center justify-center min-h-screen bg-white p-8" data-id="element-17">
      <div className="w-full max-w-[800px]" data-id="element-18">
        <h1 className="text-3xl font-bold mb-8 text-center" data-id="element-19">
          Revii Pages Directory
        </h1>
        {/* Search bar */}
        <div className="mb-6 relative" data-id="element-20">
          <div className="relative" data-id="element-21">
            <input type="text" placeholder="Search pages..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-22" />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-23">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-24" />
            </div>
          </div>
        </div>
        <div className="bg-white shadow-md rounded-lg p-6" data-id="element-25">
          <h2 className="text-xl font-semibold mb-4" data-id="element-26">Available Pages</h2>
          {filteredPages.length > 0 ? <ul className="space-y-4" data-id="element-27">
              {filteredPages.map((page, index) => <li key={index} className="border-b pb-2" data-id="element-28">
                  <Link to={page.path} className="text-blue-600 hover:text-blue-800 hover:underline text-lg" data-id="element-29">
                    {page.title}
                  </Link>
                  <p className="text-gray-600 text-sm mt-1" data-id="element-30">
                    {page.description}
                  </p>
                </li>)}
            </ul> : <p className="text-gray-500 italic" data-id="element-31">No pages match your search.</p>}
        </div>
      </div>
    </div>;
}